/*
 * src/components/TransferSuccess/SuccessLastRow.jsx
 * Description:
 * Copyright (c) 2021 PredictiveUX
 */
import React from 'react';
import get from 'lodash/get';
import moment from 'moment';

import { PaymintsNumberFormat } from 'paymints-address-autocomplete-field';
import FormatAddress from '../FormatAddress/FormatAddress';

import {
  extractNotesFromJson,
  paymintsCurrencyFormatter,
} from '../../utils/util';

import './transfer-success.css';

/**
 * Taking the purpose string and possible adjustment
 * @param {*} purpose
 */
const transformPurpose = (purpose) => {
  if (!purpose) {
    return '--';
  }
  return purpose;
};

const DisplaySummationRows = ({ transfer }) => {
  return (
    <div className="summationContainer">
      <table>
        <tbody>
          <tr>
            <td style={{ textTransform: 'capitalize' }}>{`${transformPurpose(
              transfer?.purpose,
            )} Amount`}</td>
            <td>{paymintsCurrencyFormatter(transfer?.amount || 0)}</td>
          </tr>
          {transfer?.fee && (
            <tr>
              <td>Convenience Fee</td>
              <td>{paymintsCurrencyFormatter(transfer?.fee || 0)}</td>
            </tr>
          )}
          <tr
            style={{
              borderTop: 'solid 1px #ccc',
              paddingTop: '5px',
              paddingBottom: '5px',
            }}
          >
            <td />
            <td className="transferTotalAmount">Transfer Total Amount</td>
          </tr>
          <tr>
            <td />
            <td className="transferTotal">
              <PaymintsNumberFormat
                number={+(transfer?.amount || 0) + +(transfer?.fee || 0)}
                decimals={2}
                format="currency"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const SuccessLastRow = ({ transfer }) => {
  return (
    <>
      <div className="sectionTitle">Details</div>
      <div className="detailsContainer">
        <div className="col">
          <div className="sectionTitle">Transfer Date</div>
          <p>{moment().format('MM/DD/YYYY')}</p>
        </div>
        <div className="col">
          <div className="sectionTitle">Purpose</div>
          <p style={{ textTransform: 'capitalize' }}>
            {transformPurpose(transfer?.purpose)}
          </p>
        </div>
        <div className="col">
          <div className="sectionTitle">Subject Property</div>
          <FormatAddress
            streetNumberName={get(transfer, 'propertyAddress1')}
            apartmentSuiteNumber={get(transfer, 'propertyAddress2')}
            city={get(transfer, 'propertyCity')}
            state={get(transfer, 'propertyState')}
            zipcode={get(transfer, 'propertyZipcode')}
          />
        </div>
        {transfer.office !== null ? (
          <div className="col">
            <div className="sectionTitle">Office</div>
            <p>
              {transfer.office.title} - {transfer.office.city},{' '}
              {transfer.office.state}
            </p>
          </div>
        ) : null}
        {transfer.realtor !== null ? (
          <div className="col">
            <div className="sectionTitle">Realtor</div>
            <p>
              {transfer.realtor.firstName} {transfer.realtor.lastName},{' '}
              {transfer.realtor.email}
            </p>
          </div>
        ) : null}
        <div className="col">
          <div className="sectionTitle">Note</div>
          <p>{extractNotesFromJson(transfer?.notes || '')}</p>
        </div>
      </div>

      <DisplaySummationRows transfer={transfer} />
    </>
  );

  /*

  return (
    <div className="create-account__row create-account__box">
      <div className="row">
        <div className="col-xs-12 create-account__transfer-details-title">
          Transfer Details
        </div>
      </div>
      <div className="create-account__transfer-details-row">
        <div className="create-account__transfer-details-label">
          Transfer Date
        </div>
        <div className="create-account__transfer-details-value">
          {moment().format("MM/DD/YYYY")}
        </div>
      </div>
      <div className="create-account__transfer-details-row">
        <div className="create-account__transfer-details-label">Property</div>
        <div className="create-account__transfer-details-value">
          {formatAddressStreetApartment(
            get(transfer, "propertyAddress1"),
            get(transfer, "propertyAddress2")
          )}{" "}
          {formatAddressCityStateZipCode(
            get(transfer, "propertyCity"),
            get(transfer, "propertyState"),
            get(transfer, "propertyZipcode")
          )}
        </div>
      </div>
      <div className="create-account__transfer-details-row">
        <div className="create-account__transfer-details-label">Purpose</div>
        <div className="create-account__transfer-details-value">
          <span style={{ textTransform: "capitalize" }}>
            {`${transfer?.purpose ?? " "}`}
          </span>
        </div>
      </div>
      <div className="create-account__transfer-details-row">
        <div className="create-account__transfer-details-label">Note</div>
        <div className="create-account__transfer-details-value">
          <span style={{ textTransform: "capitalize" }}>
            {extractNotesFromJson(transfer?.notes || "")}
          </span>
        </div>
      </div>
    </div>
  );
  */
};

export default SuccessLastRow;
